import ViewFactory from "../../../helpers/viewfactory";
import { getValueAtPath } from "../../../../../utils";

export default function view() {
  const $this = this;
  const { $inputs, $timer } = this;

  return (view = ViewFactory({
    NAME: 'USSD_CODE_VIEW',
    mutables: { ussdCode: 'USSD_CODE', timerCurrent: 'CURRENT_TIME' },
    constants: {
      hasBackAction: true,
      instruction: 'Dial the USSD code below on your mobile phone to complete the payment',
      get selectedBank() { return getValueAtPath($inputs, '[bank].value') },
      get timerDuration() { return $timer.duration }
    },
    back() { $this.INIT_VIEW(() => $inputs.$reset()) }
  }).call(this));
}
